module.exports = __webpack_public_path__ + "public/Icons/tonePlay.svg?0276f7e4";